import { CloseButton, DialogSubTitle, DialogToolbar } from 'apps/wrapper/src/components/shared/dialog/dialog.styles';
import moment from 'moment';
import { FC, useState } from 'react';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { IvInfo } from '../../shared/iv-info/iv-info';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const NotRegisteredWithPayerDialog: FC = (props) => {
  const { opened, onClose, isLoading, appointmentRequest, ivSummary, getProvider } = useApptRequestIvStatusDialog();
  const [provider] = useState(getProvider(ivSummary?.idProvider));

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</BoldText>
          {ivSummary?.dateReceived && <>&nbsp;- Run {moment.utc(ivSummary?.dateReceived).local().format('MMM D hA')}</>}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        {provider ? provider.name : 'Current Provider'} isn't a registered with payer{' '}
        {ivSummary?.idPayer || 'Unknown Payer'} or is tied to the wrong NPI.
        <br />
        <br />
        Please correct the issue to rerun the verification process. Alternatively, you may manually verify the patient
        or designate them as self-pay.
      </DialogSubTitle>
      <br />
      <IvInfo />
      <br /> <br />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(NotRegisteredWithPayerDialog);
